module.exports = __webpack_public_path__ + "static/media/tests-list.55e5ee20.svg";